import { ExportableFileSignatureSettings } from "./ExportableFileSignatureSettings";

class ExportableFilePopupSignatureSettings {
    public IsSaveSignature: boolean = false;
    public IsAttachOriginalDocument: boolean = false;
    public IsAlsoSendToPortal: boolean = false;
    public ExportableFileSignatureSettings: ExportableFileSignatureSettings[];

    public constructor(init?: Partial<ExportableFilePopupSignatureSettings>) {
        Object.assign(this, init);
    }
}

export { ExportableFilePopupSignatureSettings };
